export const IS_FROM_QUERY_PARAM = 'frameAdvisor'
export const START_QUERY_PARAM = 'startFa'

export const ENDPOINT_NAME = 'frameAdvisor'
